export enum GraphTemplates {
    SingleQuantities = 'Single Quantities',
    MultiQuantities = 'Multi-Valued Quantities',
    CumulativeQuantities = 'Cumulative Quantities'
}
